import {DEFAULT_PAGE} from "../../contstants";
import {GetCardholders} from "./GetCardholders";
import getDateRange from "../../utils/getDateRange";

const FilterCardholders = async (perPage, filters) => {

    const page = filters.page || DEFAULT_PAGE;
    let { dateFrom, dateTo } = getDateRange(filters.date);

    const currentDate = new Date();
    const oneMonthBefore = new Date();
    const oneMonthAfter = new Date();
    oneMonthBefore.setMonth(currentDate.getMonth() - 1);
    oneMonthAfter.setMonth(currentDate.getMonth() + 1);

    if(!dateFrom){
        dateFrom = oneMonthBefore.getTime();
    }

    if(!dateTo){
        dateTo = oneMonthAfter.getTime();
    }

    return await GetCardholders(perPage, (page - 1) * perPage,dateFrom, dateTo);
};

export default FilterCardholders;
